module.exports = __webpack_public_path__ + "img/image1-1.1297812b.png";